import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';
import { requirements } from '@/mocks/certificateData';

export default function RequirementsSection() {
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  return (
    <section className="relative py-20 md:py-28 bg-background-50">
      <div className="max-w-[800px] mx-auto px-8">
        <div className="text-center mb-12">
          {String(t('certificate.requirements.label')).split(/\n{2,}/).map((__s, __i) => (<p key={__i} className="text-accent-600 text-[13px] tracking-[0.2em] mb-5 font-label">{__s}</p>))}
          <h2 className="font-heading text-xl md:text-2xl text-foreground-900 tracking-[0.06em] mb-2">
            {lang === 'en' ? t('certificate.req.title') : requirements.title}
          </h2>
          <p className="text-accent-500 text-[15px] tracking-[0.12em] mb-4 font-label">
            {requirements.titleEn}
          </p>
          <div className="w-10 h-[1px] bg-accent-500/40 mx-auto mb-6"></div>
          <p className="text-[15px] md:text-[16px] text-foreground-500 tracking-[0.04em] leading-relaxed max-w-[650px] mx-auto">
            {lang === 'en' ? t('certificate.req.lead') : requirements.lead}
          </p>
        </div>

        <div className="space-y-4 mb-10">
          {requirements.items.map((item, idx) => (
            <div
              key={idx}
              className="flex items-start gap-4 bg-background-100/60 p-5"
            >
              <div className="w-10 h-10 flex items-center justify-center flex-shrink-0 bg-accent-500/10 rounded-full">
                <i className={`${item.icon} text-accent-500 text-base`}></i>
              </div>
              <div>
                <h3 className="text-[16px] text-foreground-800 tracking-[0.05em] font-medium mb-1">
                  {lang === 'en' ? t(`certificate.req.item.${idx}.label`) : item.label}
                </h3>
                <p className="text-[14px] text-foreground-500 tracking-[0.04em] leading-relaxed">
                  {lang === 'en' ? t(`certificate.req.item.${idx}.desc`) : item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="border border-accent-500/20 bg-accent-500/5 p-5 text-center">
          <p className="text-[14px] text-foreground-600 tracking-[0.04em] leading-relaxed">
            {lang === 'en' ? t('certificate.req.retakeNote') : requirements.retakeNote}
          </p>
        </div>
      </div>
    </section>
  );
}
